import { render, staticRenderFns } from "./DetailsContainer.vue?vue&type=template&id=28d3a5d6&"
import script from "./DetailsContainer.vue?vue&type=script&lang=js&"
export * from "./DetailsContainer.vue?vue&type=script&lang=js&"
import style0 from "./DetailsContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports